/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NarrativeType } from './NarrativeType';
import {
    NarrativeTypeFromJSON,
    NarrativeTypeFromJSONTyped,
    NarrativeTypeToJSON,
    NarrativeTypeToJSONTyped,
} from './NarrativeType';
import type { NarrativeClassifierType } from './NarrativeClassifierType';
import {
    NarrativeClassifierTypeFromJSON,
    NarrativeClassifierTypeFromJSONTyped,
    NarrativeClassifierTypeToJSON,
    NarrativeClassifierTypeToJSONTyped,
} from './NarrativeClassifierType';

/**
 * Request model for creating a new narrative
 * @export
 * @interface NarrativeCreate
 */
export interface NarrativeCreate {
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    userPrompt: string;
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    systemPrompt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    modelName: string;
    /**
     * 
     * @type {NarrativeClassifierType}
     * @memberof NarrativeCreate
     */
    classifierType: NarrativeClassifierType;
    /**
     * 
     * @type {NarrativeType}
     * @memberof NarrativeCreate
     */
    narrativeType?: NarrativeType | null;
    /**
     * 
     * @type {string}
     * @memberof NarrativeCreate
     */
    version?: string;
}



/**
 * Check if a given object implements the NarrativeCreate interface.
 */
export function instanceOfNarrativeCreate(value: object): value is NarrativeCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userPrompt' in value) || value['userPrompt'] === undefined) return false;
    if (!('modelName' in value) || value['modelName'] === undefined) return false;
    if (!('classifierType' in value) || value['classifierType'] === undefined) return false;
    return true;
}

export function NarrativeCreateFromJSON(json: any): NarrativeCreate {
    return NarrativeCreateFromJSONTyped(json, false);
}

export function NarrativeCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'userPrompt': json['user_prompt'],
        'systemPrompt': json['system_prompt'] == null ? undefined : json['system_prompt'],
        'modelName': json['model_name'],
        'classifierType': NarrativeClassifierTypeFromJSON(json['classifier_type']),
        'narrativeType': json['narrative_type'] == null ? undefined : NarrativeTypeFromJSON(json['narrative_type']),
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function NarrativeCreateToJSON(json: any): NarrativeCreate {
    return NarrativeCreateToJSONTyped(json, false);
}

export function NarrativeCreateToJSONTyped(value?: NarrativeCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'user_prompt': value['userPrompt'],
        'system_prompt': value['systemPrompt'],
        'model_name': value['modelName'],
        'classifier_type': NarrativeClassifierTypeToJSON(value['classifierType']),
        'narrative_type': NarrativeTypeToJSON(value['narrativeType']),
        'version': value['version'],
    };
}

